import { useNavigate } from 'react-router';
import { FilePlus2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function NewReportButton({ fundId }: { fundId: string }) {
  const navigate = useNavigate();

  return (
    <Button onClick={() => navigate(`/app/funds/${fundId}/reports/new`)}>
      <FilePlus2 className="mr-2 h-4 w-4" />
      New report
    </Button>
  );
}
